import React from 'react'

import { Consumer } from './formProvider'

const CheckBox = props => {
    const {
        name = null,
        className = '',
        value = '',
        label = null,
        checked = false,
    } = props

    return (
        <Consumer>
            {({ handleCheck }) => (
                <React.Fragment>
                    <span className="withlabel">
                        <input
                            id={name}
                            name={name}
                            className={`input-base hs-checkbox inline ${className}`}
                            type="checkbox"
                            onChange={handleCheck(name)}
                            value={value}
                            checked={checked}
                        />
                        <label
                            className={"hs-checkbox__label"}
                            htmlFor={name}
                            dangerouslySetInnerHTML={{ __html: label }}
                        />
                    </span>
                </React.Fragment>
            )}
        </Consumer>
    )
}

export default CheckBox
